import { Component, Input, OnInit } from '@angular/core';

export interface AppIcon {
  icon: string;
  colorCode: string;
}

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() icon: AppIcon;

  constructor() { }

  ngOnInit(): void {
  }

}
